import { EmployeeAccessRolePrivilege } from "../types";

export enum UserPrivileges {
    EMPLOYEE_PRIV_ADMIN = 800,
    EMPLOYEE_PRIV_UPDATE_TIMESHEET = 690,
    USER_PRIV_UPDATE_REPORTING_EMP_TIMESHEETS = 550,
}

export const isPrivilege = (privileges?: EmployeeAccessRolePrivilege[], rule?: UserPrivileges): boolean => {
    if (!privileges || !rule || privileges.length === 0) {
        return false;
    }
    
    // Check if any privilege matches the rule
    return privileges.some(privilege => {
        const idCheck = privilege.os_role_privileges_definition_id == rule;
        const codeCheck = privilege.os_role_privilege_code == UserPrivileges[rule];
        
        return idCheck || codeCheck;
    });
};
